import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { TarcaComponent } from './tarca/tarca.component';
import { VecTarcComponent } from './vec-tarc/vec-tarc.component';
import { RezultatiComponent } from './rezultati/rezultati.component'; // Import your new ScoresComponent
import { StrelciComponent } from './strelci/strelci.component';
import { TekmeComponent } from './tekme/tekme.component';
import { CategoriesComponent } from './categories/categories.component'; // Add this import
import { KlubiComponent } from './klubi/klubi.component';
import { RezultatiTekemComponent } from './rezultati-tekem/rezultati-tekem.component';
import { LoginComponent } from './login/login.component';
import { AuthGuard } from './guards/auth.guard';
import { LoginGuard } from './guards/login.guard';

import { SettingsComponent } from './settings/settings.component';

const routes: Routes = [
  { path: '', redirectTo: '/login', pathMatch: 'full' },
  { path: 'login', component: LoginComponent, canActivate: [LoginGuard] },
  { path: 'tarca', component: TarcaComponent, canActivate: [AuthGuard] },
  { path: 'tarca/:id', component: TarcaComponent, canActivate: [AuthGuard] },
  { path: 'tarce', component: VecTarcComponent, canActivate: [AuthGuard] },
  { path: 'rezultati', component: RezultatiComponent, canActivate: [AuthGuard] },
  { path: 'strelci', component: StrelciComponent, canActivate: [AuthGuard] },
  { path: 'tekme', component: TekmeComponent, canActivate: [AuthGuard] },
  { path: 'kategorije', component: CategoriesComponent, canActivate: [AuthGuard] },
  { path: 'klubi', component: KlubiComponent, canActivate: [AuthGuard] },
  { path: 'rezultati-tekem/:competitionId', component: RezultatiTekemComponent, canActivate: [AuthGuard] },
  { path: 'nastavitve', component: SettingsComponent, canActivate: [AuthGuard] }
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule]
})
export class AppRoutingModule { }